import { Component } from 'react';
import PropTypes from 'prop-types';
//import './table-cell.scss';
import { GeckoTableCellModel } from '../../../../';

class GeckoTableCellBase extends Component {
  findInObject(value, key) {
    if (typeof key === 'string') {
      const keyParts = key.split('.');
      const foundValue = keyParts.reduce((value, keyPart) => {
        if (value === null) {
          return null;
        }
        if (value[keyPart] === undefined) {
          return null;
        }
        return value[keyPart];
      }, value);
      if (foundValue === undefined) {
        return null;
      }
      return foundValue;
    }
    return null;
  }

  cell() {
    return this.props.col;
  }

  renderValue() {
    const row = this.props.row;

    let value = this.findInObject(row, this.cell().key);

    // Run custom value render
    if (this.cell().render) {
      value = this.cell().render(value, row, this.cell(), this.props.index);
    }

    if (this.cell().renderComponent) {
      value = this.cell().renderComponent(
        value,
        row,
        this.cell(),
        this.props.index
      );
    }

    return value;
  }

  render() {
    return null;
  }
}

GeckoTableCellBase.propTypes = {
  col: PropTypes.shape(GeckoTableCellModel).isRequired,
};

export default GeckoTableCellBase;
